// Used for the toggle button in some analytics pages.
export const METRIC_KEY = {
  TURNOVER: 'turnover',
  UNIT: 'unit',
};
